// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Alert, Stack, Text } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import type { JSX } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { PageHeader } from '../../components/layout/PageHeader';
import { ScriptSureIFrame } from '../../components/prescribing/ScriptSureIFrame';

export function ScriptSurePrescribingPage(): JSX.Element {
  const { patientId } = useParams<{ patientId: string }>();
  const [searchParams] = useSearchParams();
  const prescriptionId = searchParams.get('prescriptionId');

  if (!patientId) {
    return <Alert icon={<IconAlertCircle size={18} />} color="red" title="Patient not found" />;
  }

  return (
    <Stack gap="md" p="md">
      <PageHeader title={prescriptionId ? 'Edit prescription in ScriptSure' : 'Prescribe'} />
      {prescriptionId && (
        <Alert color="blue" title="Find the existing prescription in ScriptSure">
          <Text size="sm">
            ScriptSure controls prescription editing. Search for MedicationRequest/{prescriptionId} and make the
            amendment there.
          </Text>
        </Alert>
      )}
      <ScriptSureIFrame
        patientId={patientId}
        title="ScriptSure prescribing"
        loadingLabel="Preparing ScriptSure prescribing…"
      />
    </Stack>
  );
}
